<mat-card class="card-style px-6 py-6 pt-0 dialog-fork">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title>
      @if (mode === 'proposta') {
        Solicitar precificação ao Compras
      } @else {
        Gerar novo tarifário
      }
    </mat-card-title>
    <button class="btn-icon" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <div class="message mt-3">
    <mat-icon class="info-icon">info</mat-icon>
    <span>
      @if (mode === 'proposta') {
        As paradas adicionadas não correspondem ao tarifário
        <b>{{ tarifarioCodigo }}</b>. O item será enviado ao
        <b>Compras</b> para precificar um tarifário compatível com essas paradas.
        O tarifário original permanece inalterado.
      } @else {
        As paradas foram alteradas. Isso vai gerar um <b>novo tarifário</b>
        (cópia de <b>{{ tarifarioCodigo }}</b>) com este itinerário, que será
        enviado para <b>Compras precificar</b>. O tarifário original permanece
        inalterado e ativo.
      }
    </span>
  </div>

  <div class="diff mt-4">
    <div class="diff-header">
      <div class="col-ordem">#</div>
      <div class="col-side">Antes</div>
      <div class="col-side">Depois</div>
      <div class="col-status">Status</div>
    </div>
    @for (row of diff; track row.ordem) {
      <div class="diff-row" [class]="'status-' + row.status">
        <div class="col-ordem">{{ row.ordem }}</div>
        <div class="col-side">{{ paradaLine(row.antes) }}</div>
        <div class="col-side">{{ paradaLine(row.depois) }}</div>
        <div class="col-status">
          @switch (row.status) {
            @case ('igual') { <span>—</span> }
            @case ('alterada') { <span class="tag tag-alt">Alterada</span> }
            @case ('adicionada') { <span class="tag tag-add">Adicionada</span> }
            @case ('removida') { <span class="tag tag-rem">Removida</span> }
          }
        </div>
      </div>
    }
  </div>

  <div class="flex justify-end gap-2 mt-4">
    <button mat-stroked-button class="btn-tg-outline" (click)="cancel()">
      Cancelar
    </button>
    <button mat-flat-button class="btn-tg" (click)="confirm()">
      @if (mode === 'proposta') {
        Enviar para Compras
      } @else {
        Gerar novo tarifário
      }
    </button>
  </div>
</mat-card>
